<template>
  <div class="radar-chart">
    <slot></slot>
    <VChart style="width: 100%; height: 100%" :option="option" autoresize></VChart>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  commonLang: String,
  chartData: Array,
});

const PAGE_TEXT = {
  'zh': {
    label1: '经济规模',
    label2: '消费能级',
    label3: '人口规模',
    label4: '商圈活跃度',
    label5: '交通便利性',
    unit: '分',
  },
  'en': {
    label1: 'Economic Scale',
    label2: 'Consumer Strength',
    label3: 'Population Size',
    label4: 'Business Activity',
    label5: 'Transport Access',
    unit: '',
  }
};

const option = computed(() => {
  if (!props.chartData || !props.chartData.length) return {};
  return {
        radar: {
          // shape: 'circle',
          indicator: [
            {
              text: PAGE_TEXT[props.commonLang].label1,
              max: 10,
              value: props.chartData[0]
            },
            {
              text: PAGE_TEXT[props.commonLang].label2,
              max: 10,
                value: props.chartData[4]
            },
            {
              text: PAGE_TEXT[props.commonLang].label3,
              max: 10,
                value: props.chartData[3]
            },
            {
              text: PAGE_TEXT[props.commonLang].label4,
              max: 10,
                value: props.chartData[2]
            },
            {
              text: PAGE_TEXT[props.commonLang].label5,
              max: 10,
                value: props.chartData[1]
            },
          ],
          name: {
            formatter: function (params, i) {
              return "{yellow|" + i.text + "\n}{white| " + i.value + `${PAGE_TEXT[props.commonLang].unit}}`;
            },
            rich: {
              yellow: {
                color: "#000000",
                fontSize: 24,
                padding: [0, 0, 6, 0],
                fontWeight:600
              },
              white: {
                color: "#000000",
                fontSize: 24,
                align:'center',
                fontWeight:600
              },
            },
          },
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            symbol: "circle",
            symbolSize:14,
            areaStyle: {
              color: "rgba(244,0,0,0.3)",
            },
            lineStyle: {
              color: "rgba(244,0,0,1)",
            },
            itemStyle:{
              color:'#FFFFFF',
              borderWidth:1,
              borderColor:"#F40000"
            },
            data: [
              {
                value: [props.chartData[0], props.chartData[4], props.chartData[3], props.chartData[2], props.chartData[1]],
                name: "Allocated Budget",
              },
            ],
          },
        ],
      };
});
</script>
<style lang="less">
.radar-chart {
  height: 100%;
  padding: 12px;
  position: relative;
}
</style>
